export const phoneNumberSeparator = (num: string) => {
  if (num.length !== 10) return num;

  return num.replace(/\B(?=(\d{2})+(?!\d))/g, " ");
};
